import { SET_ROLES, SET_PERMESSIONS } from '../constants/RoleConstants';

const initialState = {
  roles: {
    list: [],
    count: 0,
  },
  permissions: {
    list: [],
    count: 0,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ROLES: {
      return {
        ...state,
        roles: action.payload,
      };
    }

    case SET_PERMESSIONS: {
      return {
        ...state,
        permissions: action.payload,
      };
    }

    default:
      return state;
  }
}
